import React, { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { Autocomplete, Checkbox } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
export const FormAutoComplete = ({
  name,
  control,
  label,
  dataArray,
  defaultValue,
  mandatory,
  errors,
  multiple,
  id,
}) => {
  // console.log(defaultValue);
  // console.log(dataArray)
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => {
        // Map value string to full option object
        const selectedOption =
          dataArray.find(
            (option) => option.value === (value?.value ?? value) // adjust if you store string or object
          ) || null;

        return (
          <Autocomplete
            options={dataArray}
            getOptionLabel={(option) => option.label || ""}
            isOptionEqualToValue={(option, val) => option.value === val.value}
            value={multiple ? value || [] : selectedOption}
            onChange={(event, newValue) => {
              onChange(newValue);
            }}
            multiple={multiple}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {multiple && (
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={value?.some((val) => val.value === option.value)}
                  />
                )}
                {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label={label} error={!!errors?.[name]} />
            )}
          />
        );
      }}
    />
  );
};
